<ziro-collapsible-section-card
  class="animate__animated animate__fadeIn animate__faster"
  [isSwitchHidden]="true"
  [isCollapsible]="false"
>
  <div class="card-header">
    <legend class="bottom-buffer mt-0 pb-2 d-flex">
      <ziro-stacked-icon
        class="icon-sm"
        [stackedIcon]="ZiroStackedIcons[ziroIcons.CHANGE_SITE]"
        parentClass="fa-stack"
      ></ziro-stacked-icon>

      <div class="d-flex flex-column">{{ 'tkey;operations.menu.change_site.text' | translate }}</div>
    </legend>

    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading) {
      <ziro-change-site-form
        [entity]="entity"
        [cluster]="cluster"
        [initialSite]="initialSite"
        [siteSummary]="siteSummary"
        [sites]="sites"
      ></ziro-change-site-form>
    }
  </div>
</ziro-collapsible-section-card>
